import Link from "next/link";
import {
  Badge,
  ButtonGroup,
  Container,
  Description,
  FeatureItem,
  Features,
  FeatureText,
  Grid,
  ImageBackground,
  ImageContainer,
  ImageWrapper,
  Main,
  StyledButton,
  StyledImage,
  TextContainer,
  Title
} from "./styles";
import { LuArrowRight, LuCheck } from "react-icons/lu";
import { track } from "@/lib/analytics/track";

export default function Hero() {
  const scrollToPrecos = () => {
    const element = document.getElementById("precos");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  return (
    <Main>
      <Container>
        <Grid>
          <TextContainer>
            <Badge>#1 Software de Gestão Odontológica</Badge>
            <Title>Simplifique a gestão da sua clínica odontológica</Title>
            <Description>
              Aumente a produtividade e ofereça uma experiência excepcional aos
              seus pacientes com nosso software completo e intuitivo.
            </Description>
            <ButtonGroup>
              <Link
                href={`https://wa.me/5538999568521?text=${encodeURIComponent(
                  "Olá! Gostaria de solicitar uma demonstração do DentalMap."
                )}`}
                target="_blank"
                onClick={() =>
                  track({ event: "whatsapp_cta_clicked", cta_type: "demo" })
                }
              >
                <StyledButton className="primary">
                  Solicitar Demonstração <LuArrowRight size={18} />
                </StyledButton>
              </Link>
              <StyledButton className="outline" onClick={scrollToPrecos}>
                Ver planos
              </StyledButton>
            </ButtonGroup>

            <Features>
              <FeatureItem>
                <FeatureText>
                  <LuCheck size={14} />
                </FeatureText>
                Rápida adaptação
              </FeatureItem>
              <FeatureItem>
                <FeatureText>
                  <LuCheck size={14} />
                </FeatureText>
                Suporte 24/7
              </FeatureItem>
              <FeatureItem>
                <FeatureText>
                  <LuCheck size={14} />
                </FeatureText>
                14 dias grátis
              </FeatureItem>
            </Features>
          </TextContainer>

          <ImageWrapper>
            <ImageBackground />
            <ImageContainer>
              <StyledImage
                src="/images/hero-example.png"
                alt="Software de gestão odontológica em uso"
                width={600}
                height={400}
                loading="eager"
              />
            </ImageContainer>
          </ImageWrapper>
        </Grid>
      </Container>
    </Main>
  );
}
